// extracted by mini-css-extract-plugin
export default {"infoBox":"AffectedSwitchesList_infoBox__84UDR","backButton":"AffectedSwitchesList_backButton__+Pfim"};